class CartNotification extends HTMLElement {
    constructor() {
        super();
        this.addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
        console.log(this.addToCartForms);
    }

    connectedCallback() {
        this.closeButton = this.querySelector('.cart-notification-content__close button');
        this.continueShopping = this.querySelector('.cart-notification-content__buttons_continue_shopping');

        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.close.bind(this));
        }
        if (this.continueShopping) {
            this.continueShopping.addEventListener('click', this.close.bind(this));
        }
        if (this.addToCartForms.length > 0) {
            this.addToCartForms.forEach(form => {
                form.addEventListener('submit', this.open.bind(this));
            });
        }
        document.addEventListener('openCartNotification', (event) => {
            const form = event.detail.form;
            if (form instanceof HTMLFormElement) {
                this.open(form);
            } else {
                console.error('Objeto recebido não é um formulário válido:', form);
            }
        });
    }

    async open(form) {
        const formData = new FormData(form);
        
        const blockBuyButtons = form.closest('block-buy-buttons');
        const giftCardRecipientForm = blockBuyButtons?.querySelector('gift-card-recipient-form') 
            || form.querySelector('gift-card-recipient-form');
        
        if (giftCardRecipientForm) {
            const checkbox = giftCardRecipientForm.querySelector('.recipient-form__checkbox');
            if (checkbox && checkbox.checked) {
                const emailInput = giftCardRecipientForm.querySelector('.recipient-form__email');
                const nameInput = giftCardRecipientForm.querySelector('.recipient-form__name');
                const messageInput = giftCardRecipientForm.querySelector('.recipient-form__message');
                const dateInput = giftCardRecipientForm.querySelector('.recipient-form__date');
                const controlInput = giftCardRecipientForm.querySelector('input[type="hidden"][name="properties[__shopify_send_gift_card_to_recipient]"]');

                formData.delete('properties[__shopify_send_gift_card_to_recipient]');

                if (controlInput && !controlInput.disabled) {
                    formData.set('properties[__shopify_send_gift_card_to_recipient]', controlInput.value || 'if_present');
                }

                if (emailInput) {
                    formData.set('properties[Recipient email]', emailInput.value || '');
                }
                if (nameInput && nameInput.value) {
                    formData.set('properties[Recipient name]', nameInput.value);
                }
                if (messageInput && messageInput.value) {
                    formData.set('properties[Message]', messageInput.value);
                }
                if (dateInput && dateInput.value) {
                    formData.set('properties[Send on]', dateInput.value);
                }
            }
        }
        
        const data = {};
        const properties = {};
        
        formData.forEach((value, key) => {
            if (key.startsWith('properties[') && key.endsWith(']')) {
                const propertyName = key.slice(11, -1);
                properties[propertyName] = value;
            } else {
                data[key] = value;
            }
        });
        
        if (Object.keys(properties).length > 0) {
            data.properties = properties;
        }

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        await this.updateCartCountAjax();
        this.classList.add('cart-notification_opened');
        setTimeout(() => {
            this.close();
        }, 5000);
    }

    close() {
        this.classList.remove('cart-notification_opened');
    }

    async updateCartCountAjax() {
        const newCartCount = await fetch('/cart.js').then((res) => res.json());
        const cartCountBubble = document.querySelector('.cart-link__bubble');
        const cartBubbleNum = document.querySelector('.cart-link__bubble .cart-link__bubble-num');
        if (!newCartCount.item_count || !cartCountBubble) return
        cartCountBubble.classList.add("cart-link__bubble--visible");
        cartBubbleNum.textContent = newCartCount.item_count;
    }
}

customElements.define('cart-notification', CartNotification);